{
  "Notifications": "Notifications",

  "CreatedAnEvent": "created an event",
  "FormerRebel": "Former Rebel",

  "DeletedAnEvent": "deleted an event",
  "a": " a ",
  "an": " an ",
  "SeeAll": "See All",

  "ChangedTheDetails": "changed the details for event",
  "Name": "Name",
  "DateTime": "DateTime",
  "to": "to",
  "Location": "Location",
  "IsNowHappeningOnline": "Is now happening online",

  "InvitedYouToAttendAnEvent": "invited you to attend an event",
  "YouAreAttendingAs": "You are attending as",
  "SeeEvent": "See event",
  "YouAreNotGoing": "You are not going",
  "decline": "decline",
  "accept": "accept",
  "BoostedYourPost": "boosted your post in",

  "posted": "posted",
  "in": "in",
  "admin": " (admin)",
  "PostDeleted": "Post Deleted",
  "RepliedToYourPost": "replied to your post in",
  "RespondedToThread": "responded to a thread you are part of in",

  "InvitedYouToHub": "invited you to a hub",
  "YouAreNow": "You are now",
  "aMember": "a member",
  "SeeHubEvents": "See hub events.",
  "YouDeclinedThisInvitation": "You declined this invitation.",

  "InvitedYouToTheirTeam": "invited you to their team",
  "ignore": "ignore",
  "WelcomeToTheTeam": "Welcome to the team!",
  "GoToProject": "Go to project.",
  "Ignored": "Ignored",

  "SentYouKudos": "sent you kudos",
  "PlusOneKudos": "+1 kudos point",

  "SentYouNote": "sent you a note",

  "UpdatedThe": "updated the",
  "builder": "builder",

  "JustRSVPd": "just RSVP'd YES! to",

  "JoinedYourHub": "joined your hub",

  "JoinedYourProject": "joined your project",

  "LeftYourProject": "left your project",

  "SubmittedProject": "submitted a project,",
  "ForTheEvent": "for the event",

  "NoNotifications": "no notifications",
  "end": "end",
  "Invites": "Invitations",
  "NoInvitesRightNow": "no invites right now",

  "ProfileImageUploaded": "Profile Image uploaded successfully.",
  "SupportedFormats": "Image format not supported. Supported formats are jpg, jpeg, png, gif and jfif.",
  "MandatoryField": "Hm... looks like we skipped a mandatory field.",
  "InvalidEmail": "We do not recognize that as a valid email, you might be from out of this world!",
  "MessageSent": "Your message has been sent! We will get back to you shortly - promise.",
  "RequiredFields": "Please fill in all the required fields.",
  "ProjectNameAlreadyExists": "Shoot! This project name is already in use. Please select another name. But hey, it's another chance to be creative!",
  "ClickHere": "Click Here",
  "InviteTeammatesHere": "Invite teammates to your project here:",
  "InviteTeammates": "Invite Teammates",
  "CreateProject": "Create a Project",

  "EmailVerified": "Email verified!",
  "InvalidToken": "Invalid Token!",
  "EmailVerificationSent": "A verification email has been sent to",
  "VerifyHere": "Please click the link to verify!",
  "VerifyEmail": "Please verify your email address:",
  "SendVerificationEmail": "Send verification email",

  "EnterNameAndUploadLogo": "Please enter a name and upload a logo.",
  "EnterValidWebsiteURL": "Please enter a valid website url.",
  "EnterName": "Please enter a name.",
  "MinProjectRequirement": "There must be at least one project to begin judging.",
  "Error": "Oops. Something went wrong.",
  "SelectWinningTeams": "Oops. Please select the winning teams.",
  "Round": "Round",
  "RoundPart2": "is a go!",
  "HubCreated": "Hub successfully created! Please tell us a bit about your hub.",
  "HubDetailsUpdated": "Hub details updated.",
  "EnterAllRequiredFields": "Please enter all required fields.",
  "EnterEventLocation": "Please tell us where the event is going to take place, or if it is online, check the online box.",
  "EventEnding": "Oh no. Your event seems to be ending before it has started.",
  "EventUpdated": "Event successfully updated.",
  "EventDeleted": "Event successfully deleted.",
  "SelectProject": "Please select a project.",
  "ProjectSubmitted": "Project submitted!",
  "AdminCardUpdated": "Admin card updated successfully.",
  "SupportCardUpdated": "Support card updated successfully.",
  "FillAllFields": "Please fill all fields.",

  "SignupOrLoginFirst": "Please signup or login before trying to accept an invitation to create a Hub.",
  "LoginWithCorrectEmail": "Make sure you are logged in with the correct email before trying to accept an invitation!",
  "InvitationExpired": "This invitation has expired!",
  "EnterEmailToInvite": "Please enter an email address to invite.",
  "UserAlreadyHubMember": "This user is already a hub member or has a pending invitation.",
  "InvitationSent": "Invitation sent!",
  "InvitationResent": "Invitation resent!",
  "InvitationDeleted": "Invitation deleted.",
  "InvitationAccepted": "Invitation accepted successfully.",
  "TokenInvalid": "Token Invalid",
  "InvalidEmails": "The following are not valid emails:",
  "EnterEmailsToInvite": "Please enter some emails to invite. If you wish to do this later, you can skip this step.",
  "EnterSomeEmails": "Please enter some emails to invite.",
  "YouAreInvitingYourself": "You are trying to invite yourself to the event:",
  "AlreadyInvited": "The following emails are already invited or attending the event:",
  "SelectRoleType": "Please select a role type before sending invitations.",
  "InvitationsSent": "Invitations sent successfully.",
  "SignupOrLogin": "Please signup or login before trying to accept an event invitation.",

  "NoAccount": "Oops! There is no account associated with this email.",
  "CheckYourEmail": "Check your email for a link to reset your password!",
  "FillInAllFields": "Make sure to fill in all the fields.",
  "EnterFieldsProperly": "Make sure the fields are entered properly.",
  "PasswordReset": "Password successfully reset!",

  "ExperienceAdded": "Experience added!",
  "ExperienceSaved": "Experience saved!",
  "TellUs": "Tell us about yourself... then we can customize your experience!",
  "JudgeBioSaved": "Judge Bio saved!",
  "AboutSaved": "About saved!",
  "SocialLinksSaved": "Social Links saved!",
  "AwsomeWorks": "Awesome work! Now your profile can really shine!",
  "ProfileCompleted": "Profile Completed",
  "TryingToInviteYourself": "Trying to invite yourself, huh?",
  "PersonAlreadyInYourTeam": "This person is already in your team.",
  "InvitationAlreadySent": "This email has already been sent an invitation!",
  "UserAlreadyPartOfProject": "This user is already part of the project or has a pending invitation.",
  "RoleChanged": "Role Changed!",
  "TitleChanged": "Title changed!",
  "ProjectInvitationAccepted": "Project invitation accepted!",
  "LoginFirst": "Please login before trying to accept a project invitation!",
  "LoginWithCorrectEmail2": "Make sure you are logged in with the correct email before trying to accept a project invitation!",

  "ProjectAboutUpdated": "Project about updated!",
  "ProjectBackdropUploaded": "Project backdrop uploaded!",
  "SelectAnImage": "Please select an image to upload.",
  "ProjectLogoUploaded": "Project logo uploaded!",
  "ProjectDescriptionUpdated": "Project description updated!",
  "EnterNote": "Please enter a note.",
  "AnswerSaved": "Answer saved!",
  "SendSupportRequest": "Oops... something went wrong. Please send us a support request so we can resolve this issue.",

  "AccountSettingsSaved": "Account settings saved!",
  "ProjectSettingsSaved": "Project settings saved!",
  "EmailSettingsSaved": "Email settings saved!",
  "ConfirmLeavingProject": "Are you sure you want to leave this project?",
  "NewOwner": "will become the owner of this project once you leave.",
  "LeftTheProject": "You have left the project!",
  "RemovedFromProject": "You are no longer a member of this project.",
  "HubSettingsSaved": "Hub settings saved!",

  "ConfirmLeavingPage": "Are you sure you want to leave this page? Any unsaved work will be lost!",
  "NoGoBack": "No, go back",
  "YesClose": "Yes, close",
  "EnterValidEmail": "Please enter a valid email.",
  "PasswordMismatch": "Something funky going on with your two passwords - like mismatched socks.",
  "PasswordTooShort": "Your chosen password is too short to be secure. Minimum is 6 characters.",
  "EmailAddressTaken": "Darn...that email address has already been taken. If this is you, log in instead.",
  "PleaseFillAllFields": "Please fill in all the fields.",

  "EmailAlreadyAssociated": "This email address is already associated with an account.",
  "AlternativeEmailAdded": "Alternative email added. Please check your email to verify.",

  "DeletedProject": "Project deleted successfully",

  "as": "as",
  "SomethingWentWrong": "Something went wrong. Please try again."
}
